import { createAsyncThunk } from '@reduxjs/toolkit'

import { BlockedIpApi } from '../api/blockedIpApi'

export const SLICE_NAME = 'blockedIps'

export const GetBlockedIps = createAsyncThunk(
  `${SLICE_NAME}/getBlockedIps`,
  async (search: string | undefined, thunkAPI) => {
    try {
      const res = await BlockedIpApi.getAll(search)
      return res.data
    } catch (e) {
      return thunkAPI.rejectWithValue(null)
    }
  },
)

export const UpdateBlockedIp = createAsyncThunk(
  `${SLICE_NAME}/updateBlockedIp`,
  async ({ id, isActive }: { id: number; isActive: boolean }, thunkAPI) => {
    try {
      const res = await BlockedIpApi.update(id, isActive)
      return res.data
    } catch (e) {
      return thunkAPI.rejectWithValue(null)
    }
  },
)
